import useDebounce from 'hooks/useDebounce';
import React, { useContext, useEffect, useState } from 'react';
import { FaArrowLeft, FaSave } from 'react-icons/fa';
import Popup from 'reactjs-popup';
import Cookies from 'js-cookie';
import ConfirmPopup from '../UI/ConfirmPopup';
import { useAPIData } from 'hooks/useAPIData';
import { usePerms } from 'contexts/PermsContext';
import useDataRefresh from 'hooks/useDataRefresh';
import { ColorContext } from 'App';
import { Button, Form } from 'react-bootstrap';
import { autoCompleteSearch } from 'services/location/location.service';

let eventSource;
const PlacesSearch = ({
  places,
  addLocation,
  setSearching,
  noBack,
  setMapCenter,
  quickSave,
  quickLook,
  setWidgetRefresh,
}) => {
  const [searchResults, setSearchResults] = useState([]);
  const [query, setQuery] = useState('');
  const [dropDownOpen, setDropDownOpen] = useState(false);
  const [tempLocation, setTempLocation] = useState(null);
  const [fetching, setFetching] = useState(false);
  const dataRefresh = useDataRefresh();

  const [showWaitingForData, setShowWaitingForData] = useState(false);
  const [waitingForDataMessage, setWaitingForDataMessage] = useState('Loading...');
  const debouncedSearchTerm = useDebounce(query, 1000);
  const FusionData = useAPIData();
  const perms = usePerms();
  useEffect(() => {
    if (debouncedSearchTerm) {
      (async () => {
        searchAutoFill(debouncedSearchTerm);
      })();
    }
  }, [debouncedSearchTerm]);

  const theme = useContext(ColorContext);

  const searchAutoFill = async (query) => {
    let searchLocation = query.trim();
    if (searchLocation === '') {
      setSearchResults([]);
      return;
    }
    setFetching(true);
    setSearchResults([]);

    try {
      let results = await autoCompleteSearch(
        Cookies.get('latitude'),
        Cookies.get('longitude'),
        searchLocation,
      );
      results = results.data.result;

      if (results) {
        setSearchResults(results);
        setFetching(false);
      } else {
        setFetching(false);
        setSearchResults([]);
      }
    } catch (error) {
      console.error('Error fetching autocomplete data:', error);
      setFetching(false);
      setSearchResults([]);
    }
  };

  const selectLocation = (location) => {
    if (!location) return;

    if (eventSource) eventSource.close();

    const locationCheck = FusionData.isLocationReady({
      location: location,
      fetchCallback: (message) => {
        setShowWaitingForData(true);
        setWaitingForDataMessage(message);
      },
      errorCallback: (message) => {
        setShowWaitingForData(true);
        setWaitingForDataMessage(message);
      },
      successCallback: (message) => {
        setShowWaitingForData(false);
        setWidgetRefresh(new Date().toString());
        dataRefresh.setWidgetRefresh(new Date().toString());
        setTempLocation(location);
      },
    });
    if (locationCheck?.eventSource) eventSource = locationCheck.eventSource;
  };

  const tempLookAtLocation = (location) => {
    selectLocation(location);
  };

  const saveLocation = (location) => {
    if (!location) return;
    addLocation(location);
    setSearching(false);
  };

  return (
    <div>
      <div className="d-flex z-1">
        <Popup
          trigger={
            <div
              className="d-flex justify-content-between rounded-5 px-2 py-1 fs-6 z-1 bg-primary-highlight"
              style={{ minWidth: 170 }}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                setDropDownOpen(true);
              }}
            >
              {!noBack && (
                <Button onClick={() => setSearching(false)}>
                  <FaArrowLeft />
                </Button>
              )}
              <Form.Control
                className="ms-2 w-100 bg-transparent border-0"
                type="text"
                placeholder="Search for a location..."
                value={query}
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  setDropDownOpen(true);
                }}
                onChange={(e) => {
                  setQuery(e.target.value);
                }}
              />
              {perms.testPermission([8, 9, 10, 11, 12, 13], ['Create-EditPlaces']) &&
                tempLocation &&
                !quickSave && (
                  <div className="cursor-pointer" onClick={() => saveLocation(tempLocation)}>
                    <FaSave />
                  </div>
                )}
            </div>
          }
          open={dropDownOpen}
          onOpen={() => setDropDownOpen(true)}
          onClose={() => setDropDownOpen(false)}
          position={'bottom center'}
          closeOnDocumentClick
          closeOnEscape
        >
          {dropDownOpen && (
            <div className="d-flex flex-column p-1 rounded-2 bg-primary z-1" style={{ width: 200 }}>
              {searchResults.length === 0 && fetching && <div className="p-1">Loading...</div>}
              {searchResults.length === 0 && !fetching && (
                <div className="p-1">No results found</div>
              )}
              {searchResults.map((item, index) => {
                return (
                  <Button
                    key={index}
                    className="p-1"
                    style={{
                      borderBottom: index === searchResults.length - 1 ? 'none' : '1px solid white',
                    }}
                    onClick={() => {
                      setDropDownOpen(false);
                      if (quickLook) tempLookAtLocation(searchResults[index]);
                      if (quickSave) addLocation(searchResults[index]);
                    }}
                    variant="secondary"
                  >
                    {item.description || 'none'}
                  </Button>
                );
              })}
            </div>
          )}
        </Popup>
      </div>
      {showWaitingForData && (
        <ConfirmPopup
          open={showWaitingForData}
          setOpen={setShowWaitingForData}
          message={waitingForDataMessage}
          options={['Cancel']}
          callbacks={[
            () => {
              setShowWaitingForData(false);
              FusionData.cancelLocationInquiry();
            },
          ]}
          closeAction={() => {
            setShowWaitingForData(false);
            FusionData.cancelLocationInquiry();
          }}
          buttonStyles={[{ backgroundColor: theme.background, color: theme.fontColor }]}
        />
      )}
    </div>
  );
};

export default PlacesSearch;
